/**
 * breadcrumbs.js — In-memory ring buffer of the user's recent activity.
 *
 * Consumed at bug-report submission time (NOT sent in real time anywhere)
 * so we can replay the path that led to the bug without any telemetry
 * backend.
 *
 * Sources:
 *   - RouteTracker     → { type: "route", payload: { to, from } }
 *   - global click hdl → { type: "click", payload: { selector, text } }
 *   - axios intercept  → { type: "api_error", payload: { url, method, ... } }
 *   - consoleBuffer    → { type: "console", payload: { message, level } }
 *
 * Capacity is small on purpose — the most recent ~30 entries cover the
 * window of "what was the user doing just before the bug?".
 */

const MAX_ENTRIES = 30;

// Module-scoped — survives re-renders, reset on full page reload.
let _buffer = [];

/**
 * Record one breadcrumb.
 * @param {string} type - "route" | "click" | "api_error" | "console"
 * @param {object} payload - shape depends on type, see file header
 */
export function track(type, payload) {
  const entry = {
    ts: new Date().toISOString(),
    type,
    payload: payload || {},
  };
  _buffer.push(entry);
  if (_buffer.length > MAX_ENTRIES) {
    _buffer.splice(0, _buffer.length - MAX_ENTRIES);
  }
}

/** Return a *copy* of all buffered breadcrumbs (oldest first). */
export function getAll() {
  return _buffer.slice();
}

/** Wipe the buffer — useful after a successful bug submission. */
export function clear() {
  _buffer = [];
}
